export default __webpack_public_path__ + "static/media/instagram.4b9478d4.svg";